import request from '@/utils/request'

export function getEarlyLateCheckConfigApi(query) {
  return request({
    url: '/config-service/v1/early-late-check/early-late-check',
    method: 'get',
    params: query
  })
}

export function addEarlyLateCheckConfigApi(payload) {
  return request({
    url: '/config-service/v1/early-late-check/early-late-check',
    method: 'post',
    data: payload
  })
}

export function updateEarlyLateCheckConfigApi(id, payload) {
  return request({
    url: `/config-service/v1/early-late-check/early-late-check/${id}`,
    method: 'put',
    data: payload
  })
}

export function deleteEarlyLateCheckConfigApi(payload) {
  return request({
    url: '/config-service/v1/early-late-check/early-late-check',
    method: 'delete',
    data: payload
  })
}
